import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({
  open,
  title,
  body,
  handleClose,
  handleConfirm,
  ConfirmButtonText = "Confirmar",
}) {
  return (
    <div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          sx={{
            backgroundColor: "white",
            color: "#1769aa",
            justifyContent: "center",
          }}
        >
          {title}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "white" }}>
          <DialogContentText
            id="alert-dialog-slide-description"
            sx={{ color: "#1769aa" }}
          >
            {body}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: "white",
            color: "#1769aa",
            justifyContent: "space-around",
          }}
        >
          <Button onClick={handleConfirm} sx={{ color: "#1769aa" }}>
            {ConfirmButtonText}
          </Button>
          <Button onClick={handleClose} sx={{ color: "#1769aa" }}>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
